import { successSession } from './sessionSlice'
import { successOrderCreate } from './checkoutSlice'
import { createSlice, createSelector } from '@reduxjs/toolkit'
import { successLogin } from './userSlice'

const initialState = {
  count: 0,
  ids: [],
  items: [],
  loading: false,
  isFromSession: false,
  error: null,
  cacheTime: null
}

const viewed = createSlice({
  name: 'viewed',
  initialState: initialState,
  reducers: {
    requestViewed(state) {
      state.loading = true
    },
    successViewed(state, { payload }) {
      state.loading = false
      state.items = payload
      state.error = null
      state.cacheTime = Date.now()
    },
    failureViewed(state, { payload }) {
      state.loading = false
      state.error = payload
    },
    updateIds(state, { payload }) {
      state.ids = payload.ids
      state.count = payload.count
    },
    addViewedProduct(state, { payload }) {
      if (!payload?.model?.id) return state

      state.items = [
        payload,
        ...state.items.filter(item => item.model?.id !== payload.model?.id),
      ]
      state.ids = [payload.model?.id, ...state.ids.filter(_id => _id !== payload.model?.id)]
      state.count = state.ids.length
    },
    resetViewed() {
      return { ...initialState }
    },
  },
  extraReducers: {
    [successSession]: _getProductsFromSession,
    [successLogin]: _getProductsFromSession,
    [successOrderCreate]: _getProductsFromSession,
  },
})

function _getProductsFromSession(state, { payload }) {
  state.ids = payload?.views_history ?? []
  state.count = payload?.views_history_count ?? 0
  state.isFromSession = true
}

export const updateViewed = (params) => (_dispatch, _getState, { api }) => {
  api.addProductToViewed(params)
}

export const fetchHistory =
  ({ onSuccess } = {}) =>
    async (dispatch, getState, { api }) => {
      try {
        const resp = await api.history()
        const { result = 'success' } = resp
        if (result === 'success') {
          const items = resp?.data || []
          onSuccess?.(items)
          dispatch(successViewed(items))
        } else {
          dispatch(failureViewed(resp))
        }
      } catch (err) {
        dispatch(failureViewed(err.message || JSON.stringify(err)))
      }
    }

export const updateHistoryIds =
  ({ ids, count }) =>
    (dispatch, getState) => {
      dispatch(updateIds({ ids, count }))
    }


export const getViewedData = createSelector(
  state => state.viewed,
  viewedState => {
    const { loading, error, count, ids, isFromSession, items } = viewedState
    return { loading, error, count, ids, isFromSession, items }
  },
)

export const { requestViewed, successViewed, failureViewed, updateIds, addViewedProduct, resetViewed } =
  viewed.actions

export default viewed.reducer
